module.exports = __webpack_public_path__ + "static/media/30_plantilla_rec_combo_simple_cf_gaseosas_pet_1,75_ccso.51bbbbdf.png";